export function dataErr(text) {
  return "<div class='err-nodata'>" + text + "</div>";
}

export function typeIdChange(type) {
  switch (type) {
    case 3:
      return "新闻";
    case 4:
      return "公告";
    case 5:
      return "活动";
    case 6:
      return "攻略";
    default:
      return "其他公告";
  }
}

export function newsType(type) {
  switch (type) {
    case 3:
      return {
        text: "新闻",
        class: "news-event"
      };
    case 4:
      return {
        text: "公告",
        class: "news-update"
      };
    case 5:
      return {
        text: "活动",
        class: "news-important"
      };

    case 6:
      return {
        text: "攻略",
        class: "news-important"
      };
    default:
      return {
        text: "其他公告",
        class: "news-error"
      };
  }
}

export function newsRender(page, data, action) {
  var typeInfo = newsType(data.bullentinCatId);
  var style = "";
  var url = "javascript:;";
  var bid = "";
  var pageStyle = "";
  if (action) {
    style = "opacity:0;";
  }
  if (data.urlLink) {
    url = data.urlLink;
    bid = data.bullentinId;
  } else {
    url = "news-detail?id=" + data.bullentinId;
    bid = data.bullentinId;
  }
  if (page == "home") {
    pageStyle = "main__news";
  }
  if (page == "news") {
    pageStyle = "news-content";
  }
  var newsHTML =
    '<li class="' +
    pageStyle +
    '__li" style="' +
    style +
    '">\
                <a href="' +
    url +
    '" class="' +
    pageStyle +
    "__link " +
    typeInfo.class +
    '" data-bid="' +
    bid +
    '">\
                    <div class="' +
    pageStyle +
    '__info">\
                        <span class="' +
    pageStyle +
    '__info-time">' +
    data.startDate +
    '</span>\
                        <span class="' +
    pageStyle +
    '__info-text">' +
    typeInfo.text +
    '</span>\
                    </div>\
                    <div class="' +
    pageStyle +
    '__title">\
                        <span class="' +
    pageStyle +
    '__title-text">' +
    data.title +
    "</span>\
                    </div>\
                </a>\
             </li >\
        ";
  return newsHTML;
}

export function propertyNameChange(property) {
  switch (property) {
    case "火":
      return {
        property: "火",
        en: "red",
        seq: "0"
      };
    case "水":
      return {
        property: "水",
        en: "blue",
        seq: "1"
      };
    case "风":
      return {
        property: "风",
        en: "green",
        seq: "2"
      };
    case "雷":
      return {
        property: "风",
        en: "yellow",
        seq: "3"
      };
    case "光":
      return {
        property: "光",
        en: "white",
        seq: "4"
      };
    case "暗":
      return {
        property: "暗",
        en: "black",
        seq: "5"
      };
    default:
      return {
        property: "all",
        seq: "0",
        en: "red"
      };
  }
}

export function propertyNumNameChange(property) {
  switch (property) {
    case "0":
      return {
        property: "火",
        en: "red",
        seq: "0"
      };
    case "1":
      return {
        property: "水",
        en: "blue",
        seq: "1"
      };

    case "2":
      return {
        property: "风",
        en: "green",
        seq: "2"
      };
    case "3":
      return {
        property: "雷",
        en: "yellow",
        seq: "3"
      };
    case "4":
      return {
        property: "光",
        en: "white",
        seq: "4"
      };
    case "5":
      return {
        property: "暗",
        en: "black",
        seq: "5"
      };
    default:
      return {
        property: "all",
        seq: "0",
        en: "red"
      };
  }
}

export function propertyEnNameChange(property) {
  switch (property) {
    case "red":
      return {
        property: "火",
        seq: "0"
      };
    case "blue":
      return {
        property: "水",
        seq: "1"
      };
    case "green":
      return {
        property: "风",
        seq: "2"
      };

    case "yellow":
      return {
        property: "雷",
        seq: "3"
      };
    case "white":
      return {
        property: "光",
        seq: "4"
      };
    case "black":
      return {
        property: "暗",
        seq: "5"
      };
    default:
      return {
        property: "all",
        seq: ""
      };
  }
}

export function getQuery() {
  var queryStr = location.search.substr(1);
  var queryArr = queryStr.split("&");
  var data = {};
  queryArr.forEach(function(v, i) {
    data[v.split("=")[0]] = decodeURIComponent(v.split("=")[1]);
  });
  return data;
}

export function navSet() {
  var currPage = location.pathname.substr(1);
  if (currPage == "character" || currPage == "character_detail") {
    window
      .$(".nav__li[data-page=character]")
      .find("a")
      .addClass("current");
    return;
  }
  if (currPage == "news" || currPage == "news_detail") {
    window
      .$(".nav__li[data-page=news]")
      .find("a")
      .addClass("current");
    return;
  }
  if (currPage == "downloads" || currPage == "movie") {
    window
      .$(".nav__li[data-page=special]")
      .find("div")
      .addClass("current");
    return;
  }

  if (currPage == "" || currPage == "index") {
    window.$(".info-nav__li[data-page=index]").addClass("active");
    return;
  }
  window
    .$(".nav__li[data-page=" + currPage + "]")
    .find("a")
    .addClass("current");
  window.$(".info-nav__li[data-page=" + currPage + "]").addClass("active");
}

export function ajaxErr(page, err) {
  window.$.gbox.open(page + ": " + err.statusText, {
    hasCloseBtn: true
  });
  return;
}

export function codeErr(code, page, message, url) {
  if (code == -1) {
    window.$.gbox.open(page + ": " + message, {
      addClass: "default",
      hasCloseBtn: true
    });
    return;
  }
  if (code == -2) {
    window.$.gbox.open(page + ": " + message, {
      addClass: "default",
      hasCloseBtn: true,
      afterClose: url
    });
    return;
  }
  if (code !== 1) {
    window.$.gbox.open(page + ": 出现错误", {
      addClass: "default",
      hasCloseBtn: true
    });
  }
}
